module.exports = __webpack_public_path__ + "components/media-kit/static/whiteroom-desktop-6eb72991f9a4312bed4fc5fc61546a0e.png";